// public -> Menu.vue
<template>
  <v-btn
    class="itemContent"
    :style="{ 'left': isSecundary ? '16px !important' : '10px !important', 'color': isSecundary ? ColorSecundary.concat(' !important') : Color.concat(' !important'), 'height': isSecundary ? '30px !important' : '40px !important', 'width': isSecundary ? '30px !important' : '40px !important' }"
    fab
    dark
    small
    icon
    style="bottom: 0px;position:absolute;border-radius: 50%;padding: 0px !important"
    @mousedown="mouseDown"
    @mouseup="mouseUp"
    @click="onClick"
  >
    <v-icon
      :style="{ 'font-size': isSecundary ? '14px !important' : '18px !important' }"
      dark
    >
      mdi-cursor-move
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'SortMainMenu',
  props: {
    isSecundary: {
      type: Boolean,
      required: false,
      defualt: true
    }
  },
  computed: {
    ColorSecundary () {
      return this.$store.state.app.ColorSecundary
    },
    Color () {
      return this.$store.state.app.Color
    },
  },
  updated () {
    this.childrenElts = Array.from(this.$refs.tg1.$el.children)
    if (this.draggingElt) {
      var newIndex = this.$store.state.app.menus.indexOf(this.draggingItem)
      this.draggingElt = this.childrenElts[newIndex]
      if (this.draggingElt) {
        this.draggingElt.classList.add('dragging')
      }
    }
  },
  methods: {
    mouseDown (e) {
      e.preventDefault()
      e.stopPropagation()
      var target = e.target
      while (target && !target.classList.contains('itemContent')) {
        target = target.parentElement
      }
      if (target === null) return
      this.childrenElts = Array.from(target.parentElement.children)
      this.parentElement = target.parentElement
      this.list = this.parentElement.parentElement
      this.parentElement.classList.add('dragging')
      this.list.classList.add('dragging')
      var index = this.childrenElts.indexOf(target)
      this.draggingElt = target
      // this.draggingIndex = index
      this.draggingItem = this.$store.state.app.menus[index]

      target.classList.add('dragging')
      document.addEventListener('mouseup', this.mouseupListener, true)
      document.addEventListener('mousemove', this.mousemoveListener, true)
    },

    mouseupListener (e) {
      if (this.draggingElt) {
        this.draggingElt.classList.remove('dragging')
      }
      document.removeEventListener('mouseup', this.mouseupListener, true)
      document.removeEventListener('mousemove', this.mousemoveListener, true)

      if (this.draggingElt) {
        this.draggingElt.style.backgroundColor = null
      }
      this.parentElement.classList.remove('dragging')
      this.list.classList.remove('dragging')

      if (this.isSwapped) this.updateSortApi() // llamamos a la api para guardar el nuevo orden

      e.preventDefault()
    },
    onClick (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    mouseUp (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    mousemoveListener (e) {
      var target = e.target
      var dropTargetFound = false
      while (target !== null) {
        if (target.classList.contains('drop-target')) dropTargetFound = true
        if (target.classList.contains('item') && dropTargetFound) {
          if (target === this.dropTarget || target === this.draggingElt) return
          var index = this.childrenElts.indexOf(target)
          if (index >= 0) {
            if (target.classList.contains('itemContents-move')) return
            if (this.$store.state.app.menus[index] === this.draggingItem) return
            var draggingIndex = this.childrenElts.indexOf(this.draggingElt)
            this.dropTarget = target
            target.classList.add('dropping')
            console.log('swapped', draggingIndex, 'to', index)
            this.isSwapped = true
            if (draggingIndex >= 0) {
              var removedItems = this.$store.state.app.menus.splice(draggingIndex, 1)
              this.$store.state.app.menus.splice(index, 0, removedItems[0])
              // this.draggingIndex = index;
              // this.draggingElt = null;
              this.dropTarget.classList.remove('dropping')
              this.dropTarget = null
            }
            return
          }
        }
        target = target.parentElement
      }
    },
    // updateSortApi () {
    //   const body = []
    //   for (let i = 0; i < this.menus.length; i++) {
    //     this.menus[i].ORD = i // reordenamos para en el caso de que sea nuevo (los nuevos no tienen registro en la BD por lo que no se actualizan en la llamada de la API)
    //     body.push({
    //       ID: this.menus[i].ID,
    //       ORD: i,
    //       Common: this.menus[i].Common,
    //       EnterpriseID: utils.getActiveEnterprise().ID
    //     })
    //   }
      
    //   apiServices.updateItem('menus', 'sort', body).then(response => {
    //     if (response.status === 200 && response.data.affectedRows > 0) {
    //       this.message = { active: true, text: 'messages.updateOK' }
    //     }
    //   })
    //   this.isSwapped = false
    // },
  }
}
</script>

<style scope>
  /* .list .itemContent__header {
    padding: 0px;
    background-image: linear-gradient(to top, rgba(128, 128, 128, 0), rgba(0, 0, 0, 0.2));
  } */
  .itemContents .handle::after {
    cursor: move;
    /* content:"≡"; */
    padding-left:7px;
    position:absolute;
    left:0px;
  }
  .itemContents .edit::after {
    cursor: move;
    /* content:"≡"; */
    padding-right:7px;
    position:absolute;
    right:0px;
  }

  ul.itemContents {
    margin: 0;
    padding: 0;
    background-color:red;
    list-style-type: none;
  }
  .list > ul > li::before {
    cursor: move;
    /* content:"≡"; */
    padding-left:0px;
    position:absolute;
    left:0px;
  }

  ul.itemContents > li {
    margin-left:40px;
  }

  .itemContents.dragging {
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important;
  }

  .itemContents.dragging > .item:not(.dragging) .handle::after {
    /* content:">"; */
  }

  .itemContents.dragging .dragging {
    /* content:"≡"; */
  }

  .itemContents-move {
    transition: transform 0.5s;
  }

  /* div.list {
    padding: 0;
  } */
</style>
